import { Button, Form, message as antMessage, Input, Modal, Space, Spin, Typography, Alert,List,Row,Col } from 'antd';
import { DownOutlined, LoadingOutlined } from '@ant-design/icons';
import React from 'react';
import axios from '../../request/axios';

const {Text} = Typography;

class BindSecretCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      has_bind: false,
      secret: null,
      form_submitting: false
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({loading: true});
    axios.get('security/secret/get').then(res => {
      const {data} = res.data;
      this.setState({has_bind: data.has_bind,secret:data.secret});
      this.formRef && this.formRef.setFieldsValue(res.data.data);
    }).finally(() => {
      this.setState({loading: false});
    });
  }

  onFinish = (values) => {
    this.setState({form_submitting: true});
    // values.secret = this.state.secret;
    axios.post('security/secret/bind', values).then(res => {
      const {code, message, data} = res.data;
      if (!code) {
        antMessage.success('绑定成功');
        this.loadData();
      } else {
        antMessage.error(message);
      }
    }).finally(() => {
      this.setState({form_submitting: false});
    });
  };

  render() {
    return (
      <Spin spinning={this.state.loading}>
        {!this.state.has_bind &&
        <Form ref={ref => this.formRef = ref} labelCol={{span: 6}} wrapperCol={{span: 14}} onFinish={this.onFinish}>
          <Alert type='info' message={
            <Text>
              如何下载身份验证器？
              <br/>
              <Row justify="end">
                <Col span={2}>安卓手机：</Col>
                <Col span={22}>在您手机的应用市场搜索“Google身份验证器”或“Google Authenticator”，下载安装即可。拥有Google身份验证器的市场有：Google Play；应用汇；安卓市场；百度移动应用；优亿市场；安智市场 等</Col>
              </Row>
              <Row justify="end">
                <Col span={2}>苹果手机：</Col>
                <Col span={22}>应用市场，搜索“Google Authenticator”，下载安装即可</Col>
              </Row>
            </Text>}/>

          <Form.Item
            label='密钥'
            name='secret'
            extra='添加密钥到手机app“身份验证器”，账号名可自定义'
          >
            {/*<Input bordered={false} readOnly={true} style={{color: 'red'}}/>*/}
            <Text type='danger' copyable={this.state.secret}>
              {
                this.state.secret ?? <Text type='secondary'><LoadingOutlined/> 加载中...</Text>
              }
            </Text>
          </Form.Item>

          <Form.Item
            label='动态码'
            name='code'
            rules={[
              {required: true}
            ]}
          >
            <Input style={{width: 200}}/>
          </Form.Item>

          <Form.Item wrapperCol={{
            offset: 6,
            span: 10
          }}>
            <Space>
              <Button type='primary' htmlType='submit' loading={this.state.form_submitting}>
                确认绑定
              </Button>
            </Space>
          </Form.Item>
        </Form>
        }
        {
          this.state.has_bind &&
          <Space>您已绑定过身份验证器，如需解绑，请联系管理员</Space>
        }
      </Spin>
    );
  }
}

export default BindSecretCode;
